import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import swal from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
//import "./assets/css/persian-font.css";
import "./assets/css/shabnamFD-font.css";
import ArgonDashboard from "./argon-dashboard";

import "./assets/css/custom-style.css";
import "./assets/css/custom-color.min.css";
import "./assets/css/utilities.min.css";

//import "./assets/js/onlinejs/buttons.js";

//import { ExportExcel } from './assets/js/xlsx.full.min.js';

import "vue-multiselect/dist/vue-multiselect.css";
import '@cholakovdev/vue3-treeselect/dist/vue3-treeselect.css';

/* import the fontawesome */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, far);

import { useVuelidate } from '@vuelidate/core'
import { helpers, required, requiredIf, minValue, maxValue, minLength, maxLength, email, sameAs, numeric } from '@vuelidate/validators'

if ('serviceWorker' in navigator)
  navigator.serviceWorker.register('/sw.js');

const appInstance = createApp(App);

appInstance.use(store);
appInstance.use(router);

import VueExcelEditor from 'vue3-excel-editor'
appInstance.use(VueExcelEditor);

appInstance.component('fa-icon', FontAwesomeIcon);
appInstance.component('fa-layers', FontAwesomeLayers);

import ShowErrors from "@/views/components/error/showErrors.vue";
import TextInput from "@/views/components/inputs/textInput.vue";
import DeleteButton from "@/views/components/DeleteButton.vue";
import LoadingButton from "@/views/components/LoadingButton.vue";
import ApplyDateSelector from "@/views/components/ApplyDateSelector.vue";
import DatePicker from "vue3-persian-datetime-picker";
import Pagination from "@/views/components/Pagination.vue";
import StartFlow from "@/views/Cartabel/StartFlow.vue";
import RejectConfirm from "@/views/Cartabel/RejectConfirm.vue";

import VueSelect from "vue-select";
import 'vue-select/dist/vue-select.css';

appInstance.component('TextInput', TextInput);
appInstance.component('ShowErrors', ShowErrors);
appInstance.component('DeleteButton', DeleteButton);
appInstance.component('LoadingButton', LoadingButton);
appInstance.component('ApplyDateSelector', ApplyDateSelector);
appInstance.component('VueSelect', VueSelect);
appInstance.component('Pagination', Pagination);
appInstance.component('StartFlow', StartFlow);
appInstance.component('RejectConfirm', RejectConfirm);

//appInstance.component('DatePicker', DatePicker);
appInstance.use(DatePicker, {
    name: 'date-picker',
    props: {
        format: 'jYYYY/jMM/jDD',
        displayFormat: 'jYYYY/jMM/jDD',
        //inputFormat: 'jYYYYjMMjDD',
        //color: '#831f95',
        autoSubmit: true,
        clearable: true,
        editable: true,
        inputClass: 'entred-input',
        inputAttrs: {
            style: `
        border-radius: 0 0.5rem 0.5rem 0 !important;
        border-right: 1px solid #d2d6da !important;
        text-align: left;
        direction: ltr;` }
    }
})

import Toaster from '@meforma/vue-toaster';

appInstance.use(Toaster, {
    position: 'top-right',
    dismissible: true,
    pauseOnHover: true,
    useDefaultCss: true
});

let swal_option = {
    customClass: {
        confirmButton: 'btn btn-success me-3',
        cancelButton: 'btn btn-danger'
    },
    buttonsStyling: false
};

appInstance.use(swal, swal_option);
appInstance.use(ArgonDashboard);

let listYearsFn = function (parameterGroupEnum) {

    if (parameterGroupEnum == undefined || parameterGroupEnum == null)
        parameterGroupEnum = -1;

    let maxYear = appInstance.config.globalProperties.$store.state.maxOpenYear;
    let minYear = 1401;

    if (parameterGroupEnum == 35 || parameterGroupEnum == 36 || parameterGroupEnum == 32)
        minYear = 1402;

    if (parameterGroupEnum == 18)
        maxYear = 1401;

    let yearList = [];
    for (var i = minYear; i <= maxYear; i++)
        yearList.push({ value: i, title: i });

    return yearList;
}
appInstance.config.globalProperties.$monthList = [
    { title: 'فروردین', value: 1 },
    { title: 'اردیبهشت', value: 2 },
    { title: 'خرداد', value: 3 },
    { title: 'تیر', value: 4 },
    { title: 'مرداد', value: 5 },
    { title: 'شهریور', value: 6 },
    { title: 'مهر', value: 7 },
    { title: 'آبان', value: 8 },
    { title: 'آذر', value: 9 },
    { title: 'دی', value: 10 },
    { title: 'بهمن', value: 11 },
    { title: 'اسفند', value: 12 },
];
appInstance.config.globalProperties.$yearList = listYearsFn;
appInstance.config.globalProperties.$useVuelidate = useVuelidate;
appInstance.config.globalProperties.$helpers = helpers;
appInstance.config.globalProperties.$req = required;
appInstance.config.globalProperties.$minVal = minValue;
appInstance.config.globalProperties.$maxVal = maxValue;
appInstance.config.globalProperties.$minLen = minLength;
appInstance.config.globalProperties.$maxLen = maxLength;
appInstance.config.globalProperties.$email = email;
appInstance.config.globalProperties.$sameAs = sameAs;
appInstance.config.globalProperties.$num = numeric;
let fnReqDateValidator = function (value) {
    if (!value || value == '' || (value ?? '').toString().trim() == '' || value == 0) return false;
    return true;
};
appInstance.config.globalProperties.$reqDate = function (msg) { return helpers.withMessage(msg, fnReqDateValidator) }

let fnReqVal = function (value) {
    if ((value ?? '').toString().trim() == '' || value == 0 || value == []) return false;
    return true;
};
let fnReqVal_zeroValid = function (value) {
    if ((value ?? '').toString().trim() == '') return false;
    return true;
};
appInstance.config.globalProperties.$reqVal = function (msg, zeroIsValid = false) {
    if (zeroIsValid == true)
        return helpers.withMessage(`گزینه ${msg} اجباری می باشد`, fnReqVal_zeroValid);
    else
        return helpers.withMessage(`گزینه ${msg} اجباری می باشد`, fnReqVal);
}
appInstance.config.globalProperties.$reqVal0 = function (msg) {
    return helpers.withMessage(`گزینه ${msg} اجباری می باشد`, fnReqVal_zeroValid);
}

let check_mobile = function (value) {
    if (!value || value == '') return true;
    var regex = new RegExp("^(\\+98|0)?9\\d{9}$");
    return regex.test(value);
}
appInstance.config.globalProperties.$mobile = check_mobile;

let isValidIranianNationalCode = function (input) {
    if (!input || input == '' || (input ?? '').toString().trim() == '') return true;
    if (input == '1111111111') return true;

    //while (input.length < 10)
    //    input = '0' + input;

    if (!isNaN(input)) input = input.toString();

    input = input.padStart(10, '0');

    if (!/^\d{10}$/.test(input)) return false;
    const check = +input[9];
    const sum = input.split('').slice(0, 9).reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
    return sum < 2 ? check === sum : check + sum === 11;
}

appInstance.config.globalProperties.$natinalCode = isValidIranianNationalCode;

appInstance.config.globalProperties.$reqIf = function (msg, fn_status) {
    return helpers.withMessage(`گزینه ${msg} اجباری می باشد`, requiredIf(fn_status));
}

appInstance.config.globalProperties.globalCheckRangeValidGridValue = function (rowInfo) {


    let newVal = rowInfo[0];
    //let oldVal = rowInfo[1];
    let row = rowInfo[2];
    //let field = rowInfo[3];

    //console.log(rowInfo)  // show all the arguments: newVal, oldVal, oldRow, field

    if (typeof (newVal) == 'string' && newVal.trim() == "") return true;

    let val = 0;

    if (typeof (newVal) == 'string')
        val = parseFloat(newVal);

    if (row.minValue != null && val < row.minValue) {
        this.$toast.error(`حداقل مقدار مجاز ${row.minValue} می باشد`);
        return false;
    }
    if (row.maxValue != null && val > row.maxValue) {
        this.$toast.error(`حداکثر مقدار مجاز ${row.maxValue} می باشد`);
        return false;
    }

}

appInstance.mount("#app");

let moment = require('moment-jalaali');

// apply global filters
appInstance.config.globalProperties.$filters = {
    toPersianNumber(number) {

        if (number == null || number == undefined) return '';

        const persian = {
            0: "۰", 1: "۱", 2: "۲", 3: "۳", 4: "۴", 5: "۵", 6: "۶", 7: "۷",
            8: "۸", 9: "۹"
        };
        if (typeof (number) != 'object')
            number = number.toString().split("");

        let persianNumber = ""
        for (let i = 0; i < number.length; i++) {
            if (number[i] < '0' || number[i] > '9') continue;
            number[i] = persian[number[i]];
        }
        for (let i = 0; i < number.length; i++) {
            persianNumber += number[i];
        }
        return persianNumber;
    },
    miladiToShamsiDate: function (date) {
        return moment(date, 'YYYY-M-D').format('jYYYY/jMM/jDD');
    },
    shamsiToMiladiDate: function (date) {
        //var moment = require('moment-jalaali');
        return moment(date, 'jYYYY-jM-jD').format('YYYY-MM-DD');
    },
    shamsiToMonthYear: function (date) {
        return moment(date, 'jYYYY-jM-jD').format('jMMMM jYYYY');
    },
    getMonthOfShamsiDate: function (date) {
        return moment(date, 'jYYYY-jM-jD').format('jMMMM');
    },
    getMonthOfMonthNumber: function (month) {
        return moment(month, 'jM').format('jMMMM');
    },
    getMonthNo: function (date) {
        return moment(date, 'jYYYY-jM-jD').format('jMM');
    },
    getYearNo: function (date) {
        return moment(date, 'jYYYY-jM-jD').format('jYYYY');
    },
    toDateString: function (date) {
        if (!date || date == '' || date == 0) return '';
        date = String(date);
        date.replace(/\//g, '');
        if (date.length != 8) return date;
        date = date.slice(0, 4) + "/" + date.slice(4);
        date = date.slice(0, 7) + "/" + date.slice(7);
        return date;
    },
    toSpacedDateString: function (date) {
        if (!date || date == '' || date == 0) return '';
        date = String(date);
        date.replace(/\//g, '');
        if (date.length != 8) return date;
        date = date.slice(0, 4) + " / " + date.slice(4);
        date = date.slice(0, 9) + " / " + date.slice(9);
        return date;
    },
    toTimeString(time) {
      if (!time) {
        return '';
      }
      time = String(time);
      return time.slice(0, 2) + ":" + time.slice(2, 4) + ":" + time.slice(4, 6);
    },
    minutesToTimeString(minutes) {
      let hours = Math.floor(minutes / 60);
      let remainder = minutes % 60;

      return String(hours).padStart(2, "0") + ":" + String(remainder).padStart(2, "0");
    },
    toEightDigitString(num) {
      if (!num) {
        return '';
      }
      num = String(num);
      return num.slice(0, 4) + " " + num.slice(4, 8);
    },
    toDateInt: function (date) {
        if (!date || date == '' || date == 0) return 0;
        date = String(date);
        date = date.replace(/\//g, '');
        return parseInt(date);
    },
    toInt: function (date) {
        if (!date || date == '' || date == 0) return 0;
        date = String(date);
        return parseInt(date);
    },
    toggleDate: function (date) {
        if (!date || date == '') return 0;
        if (date == 0) return '';

        if (typeof (date) == 'number') return this.toDateString(date);

        if (date.indexOf('/') > -1)
            return this.toDateInt(date);
        else
            return this.toDateString(date);
    },
    numberSperator: function (value) {
        if (!value || value == '' || value == 0) return 0;
        if (typeof (value) == 'number') value = String(value);
        return value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    isValidNationalCode: isValidIranianNationalCode,
    firstCharUpperCase: function (word) {
        const firstLetter = word.charAt(0)

        const firstLetterCap = firstLetter.toUpperCase()

        const remainingLetters = word.slice(1)

        return firstLetterCap + remainingLetters
    },
    formatBytes(bytes, decimals = 1) {
      if (!+bytes) return '0 Bytes'
  
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  
      const i = Math.floor(Math.log(bytes) / Math.log(k))
  
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }
}
